// Mapping My Data : International Code
export const classicInternationalMeasurementUnits = {
    "1": "H87",
    "2": "KGM",
    "3": "LTR",
    "4": "E48",
    "5": "MTR",
    "6": "MTK",
    "7": "MTQ",
    "8": "H87",
}
